import { useNavigate } from "flemo";
import { ChevronLeftIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export function Header() {
  const { pop } = useNavigate();

  return (
    <header className="p-5 pt-2 flex items-center gap-2">
      <Button type="button" variant="ghost" size="icon" aria-label="뒤로가기" onClick={pop}>
        <ChevronLeftIcon className="size-5 text-muted-foreground" />
      </Button>

      <h1 className="text-xl font-semibold">설정</h1>
    </header>
  );
}
